<template >
<div>
  <v-row>
    <!-- <v-col cols="12" md="6">
      <h1>經費核銷申請</h1>
    </v-col> -->
    <v-col cols="4">
    </v-col>
    <v-col cols="12" md="8" class="d-flex justify-end w-100">
      <div v-if="(formData.status==flow[0].value||formData.status==flow[2].value)&&!isDelete&&userDataCookie.depNo==formData.deptNo"
      class="d-flex justify-end w-100"
      >
        <v-btn v-if="reimburseApplyNo" color="primary"  @click="editSave" variant="tonal" 
        :loading="loadingBtn"
        class="mr-2">
          編輯儲存
        </v-btn>
        <v-btn v-else @click="save" 
        :loading="loadingBtn"
        color="primary" variant="tonal" class="mr-2">
          儲存
        </v-btn>
        <v-btn v-if="reimburseApplyNo&&userDataCookie.userno==formData.createEmpNo" 
        :loading="loadingBtn"
        color="error" variant="tonal" class="mr-2" @click="deleteBtn">
          刪除
        </v-btn>
        <v-btn v-if="reimburseApplyNo&&isAssociationContact(userDataCookie, submissionAsContact)" color="success" variant="tonal" class="mr-2" 
        :loading="loadingBtn"
        @click="send">
          送出
        </v-btn>
      </div>
        <VBtn
        v-if="formData.reimburseApplyNo" 
        :loading="loadingBtn"
        @click="clickSettlement"
        class="mr-2" variant="tonal" color="warning" >
          結算表
        </VBtn>
      <div v-if="(formData.status==flow[1].value||formData.status==flow[11].value)&&reimburseApplyNo" class="d-flex justify-end">
        <VBtn @click="revoke"
          v-if="formData.status==flow[1].value && actionBtn && actionBtn.actions&&actionBtn.actions.ableToRevoke"
          :loading="loadingBtn"
          class="mr-2" variant="tonal" color="error" >
          收回
        </VBtn>
        <!-- <v-btn v-if="actionBtn && actionBtn.formActions && actionBtn.formActions.ableToApprove"
         @click="editInSubmit" variant="tonal" class="mr-2">
         編輯儲存</v-btn> -->
        <VBtn
        @click="editInSubmit"
        v-if="actionBtn&& actionBtn.actions&&actionBtn.actions.ableToApprove"
        :loading="loadingBtn"
        class="mr-2" variant="tonal" color="primary" >
          編輯儲存
        </VBtn>
        <VBtn
        @click="returnedForRevision"
        v-if="actionBtn&& actionBtn.actions&&actionBtn.actions.ableToApprove"
        :loading="loadingBtn"
        class="mr-2" variant="tonal" color="warning" >
          回覆修正
        </VBtn>
        <VBtn
        @click="rejected"
        v-if="actionBtn&& actionBtn.actions&&actionBtn.actions.ableToReject"
        :loading="loadingBtn"
        class="mr-2" variant="tonal" color="error" >
          駁回
        </VBtn>
        <VBtn
        @click="pass"
        v-if="actionBtn&& actionBtn.actions&&actionBtn.actions.ableToApprove"
        :loading="loadingBtn"
        variant="tonal" class="mr-2" color="primary" >
          通過
        </VBtn>
      </div>
      <!-- 財務按鈕 -->
      <div v-if="formData.status==flow[7].value&&reimburseApplyNo" class="d-flex justify-end">
        <VBtn @click="FreturnedForRevision"
          v-if="actionBtn&& actionBtn.actions&&actionBtn.actions.ableToApprove"
          :loading="loadingBtn"
          class="mr-2" variant="tonal" color="primary" >
          財務退回修正
        </VBtn>
        <VBtn
        @click="Fapproved"
        v-if="actionBtn&& actionBtn.actions&&actionBtn.actions.ableToReject"
        :loading="loadingBtn"
        class="mr-2" variant="tonal" color="error" >
          財務核准
        </VBtn>
      </div>
      <!-- <v-btn to="/tca/erm/ExpenseReimbursementCenterList" color="secondary" variant="tonal">回前頁</v-btn> -->
    </v-col>
  </v-row>
  <v-form ref="formRef">
    <v-row class="mb-0">
      <v-col cols="12" md="8">
        <v-card class="w-100 h-100">
          <v-card-item>
            <v-row>
              <v-col cols="12" md="6">
                <div class="text-subtitle-2">經費需求項目名稱-經費預算申請單號<Required/></div>
                <v-autocomplete
                  :readonly="formData.status!==flow[0].value"
                  v-model="formData.activityTitle"
                  :items="activityNames"
                  required
                  :rules="[rules.required]"
                  item-title="projectTitle"
                  item-value="applyNo"
                  :item-props="item => ({ 
                    disabled: item.applied === 'Y',
                    title: item.applied === 'Y' ? `${item.projectTitle} (變更流程中)` : item.projectTitle 
                  })"
                  @update:model-value="handleActivityTitle"
                  id="經費需求項目名稱-經費預算申請單號"
                  prepend-inner-icon="tabler-search"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" class="mt-5 d-flex">
              <v-checkbox
                @change="handleActivityTitle('Y')"
                :readonly="formData.status!==flow[0].value"
                v-model="formData.supplementary"
                :label="`補充核銷(顯示所有已申請活動名稱)-${formData.supplementary?'是':'否'}`"
              ></v-checkbox>
              </v-col>
              <v-col cols="12" md="12">
                <div class="text-subtitle-2">活動名稱(國內外參賽、移訓等)<Required/></div>
                <v-select
                  :readonly="formData.status!==flow[0].value"
                  id="活動名稱"
                  v-if="formData.status==flow[0].value"
                  v-model="formData.project"
                  :items="displayProjectItemList"
                  :hint="checkbox?'顯示未申請項目，請關閉補充核銷':'如需顯示被已被申請項目，請開啟補充核銷'"
                  multiple
                  persistent-hint
                  required
                  :rules="[rules.required]"
                  item-title="displayTitle"
                  item-value="scheduleId"
                  @update:model-value="handleProject"
                  :disabled="!formData.activityTitle"
                  no-data-text="尚無資料"
                ></v-select>
                <v-text-field v-else v-model="formData.activityName" readonly></v-text-field>
              </v-col>
              <!-- <v-col cols="12" md="6">
                <div class="text-subtitle-2">活動名稱<Required/></div>
                <v-text-field v-model="formData.activityName" required :rules="[rules.required]"></v-text-field>
              </v-col> -->
              <v-col cols="12" md="4" class="mt-5 d-flex">
                <v-btn v-if="formData.activityTitle&&formData.activityName.length>0" 
                color="primary" class="mr-2"
                @click="handleDialogVisiable"
                icon >
                  <VIcon icon="tabler-file-download"></VIcon>
                </v-btn>
                <v-btn v-else color="primary" class="mr-2"
                @click="handleDialogVisiable"
                :disabled="formData.activityTitle&&formData.project.length<1"
                  ><VIcon icon="tabler-file-download" class="mr-2"></VIcon
                  >載入行程</v-btn
                >
                <div v-if="formData.activityTitle" class="">
                  <!-- <div class="d-flex justify-space-between w-100" 
                  >
                    <div>
                      經費需求總金額:${{journey.expenseTotal?journey.expenseTotal:'0'}}
                    </div>
                    <div>
                      需求已花費總金額:${{journey.reimburseTotal?journey.reimburseTotal:'0'}}
                    </div>
                  </div> -->
                </div>
                <div v-else>
                  <div class="d-flex align-center">
                    <div>請先選擇預算申請及活動名稱方可載入行程</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-subtitle-2">活動起始日期<Required/></div>
                <AppDateTimePicker id="活動起始日期" v-model="formData.startDate" placeholder="請選擇日期" :config="{ maxDate:formData.endDate??''}" :rules="[rules.required]"/>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-subtitle-2">活動結束日期<Required/></div>
                <AppDateTimePicker
                  id="活動結束日期"
                  v-model="formData.endDate"
                  placeholder="請選擇日期"
                  :rules="[rules.required]"
                  :config="{ minDate:formData.startDate??''}"
                />
              </v-col>
              <v-col cols="12" md="9">
                <div class="text-subtitle-2">活動地點<Required/></div>
                <v-text-field
                  id="活動地點"
                  v-model="formData.location" :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <div class="text-subtitle-2">總人數<Required/></div>
                <v-text-field v-model="formData.peopleCount" 
                 id="總人數"
                type="number"
                :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col cols="12" >
                <div class="text-subtitle-2">參加人員<Required/></div>
                <v-textarea
                auto-grow
                rows="1"
                id="參加人員"
                append-inner-icon="tabler-user-plus"
                @click:append-inner="showParticipantDialog"
                v-model="formData.participants" :rules="[rules.required]"></v-textarea>
              </v-col>
              <VDialog
                v-model="showAddParticipantDialog"
                width="500"
                scrollable
                persistent
              >
              <dialog-close-btn @click="showAddParticipantDialog = false"></dialog-close-btn>
                <v-card>
                  <v-card-title>參加人員</v-card-title>
                  <v-card-text style="height: 80%;">
                    <v-data-table :items="participantName" no-data-text="尚無資料" 
                    :headers="[{title:'姓名',key:'1'},{title:'職稱',key:'0'}]"
                    v-model="selectedParticipant"
                    show-select
                    return-object
                    items-per-page="-1"
                    ></v-data-table>
                  </v-card-text>
                  <v-card-actions class="d-flex justify-end">
                    <v-btn color="primary" @click="addParticipant" :disabled="selectedParticipant.length===0">新增至參加人員</v-btn>
                  </v-card-actions>
                </v-card>
              </VDialog>
            </v-row>
          </v-card-item>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="w-100 h-100">
          <v-card-item>
            <v-row>
            <UserInfo
            :isShow="[true,true,true,true,false,false]"
            :application-number="reimburseApplyNo"
            :status="formData.status"
            issue-date=""
            document-number=""
            :user-info="formData.applyEmpNo"
            status-component="ExpenseReimbursement"
            >
              <template #extra>
                <v-col cols="6">
                  <v-list-item>
                    <!-- <v-list-item-content> -->
                      <v-list-item-title>經費預算總金額</v-list-item-title>
                      <v-list-item-subtitle>
                        ${{journey.expenseTotal&&formData.project.length>0?Number(journey.expenseTotal).toLocaleString():'0'}}
                      </v-list-item-subtitle>
                    <!-- </v-list-item-content> -->
                  </v-list-item>
                </v-col>
                <v-col cols="6">
                  <v-list-item>
                    <!-- <v-list-item-content> -->
                      <v-list-item-title>預算已花費總金額</v-list-item-title>
                      <v-list-item-subtitle>
                        ${{journey.reimburseTotal&&formData.project.length>0?Number(journey.reimburseTotal).toLocaleString():'0'}}
                      </v-list-item-subtitle>
                    <!-- </v-list-item-content> -->
                  </v-list-item>
                </v-col>
              </template>
            </UserInfo>
            </v-row>
          </v-card-item>
        </v-card>
      </v-col>
    </v-row>
    <v-card v-if="formData.status!==flow[0].value">
      <v-card-item>
        <v-card-title> 審議意見 </v-card-title>
        <v-textarea rows="1" auto-grow v-model="formData.reviewComment" variant="outlined"></v-textarea>
      </v-card-item>
    </v-card>
    <div v-if="formData.status!==flow[0].value">
      <!-- 簽核歷程 -->
      <SignOffHistory
        :form-id="formData.formId"
        :refresh="formData.refreshForm"
      />
    </div>
    <v-card class="mt-5">
      <v-card-item>
        <v-card-title> 收入科目 </v-card-title>
        <v-row
          class="mt-1"
        >
          <v-col cols="12" md="6">
            <div class="text-subtitle-2">補助單位</div>
            <v-text-field 
            bg-color="#F5F5F5"
            model-value="國訓總補助" readonly></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <div class="text-subtitle-2">補助金額</div>
            <v-text-field 
            bg-color="#F5F5F5"
            :model-value="totalAmount.totalSubsidyAmount?Number(totalAmount.totalSubsidyAmount).toLocaleString():'0'" 
            readonly></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <div class="text-subtitle-2">補助單位</div>
            <v-text-field 
            bg-color="#F5F5F5"
            model-value="協會自籌款" readonly></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <div class="text-subtitle-2">補助金額</div>
            <v-text-field 
            bg-color="#F5F5F5"
            :model-value="totalAmount.totalSelfFundedAmount?Number(totalAmount.totalSelfFundedAmount).toLocaleString():'0'" 
            readonly></v-text-field>
          </v-col> 
          <v-col cols="12" md="6">
            <div class="text-subtitle-2">補助單位</div>
            <v-text-field 
            bg-color="#F5F5F5"
            model-value="其他政府補助" readonly></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <div class="text-subtitle-2">補助金額</div>
            <v-text-field 
            bg-color="#F5F5F5"
            :model-value="totalAmount.totalGovAmount?Number(totalAmount.totalGovAmount).toLocaleString():'0'"
            readonly></v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="mt-1"
          v-for="(income, index) in formData.incomes"
          :key="index"
        >
          <v-col cols="12" md="5">
            <div class="text-subtitle-2">補助單位<Required/></div>
            <v-text-field 
            :id="'補助單位-'+(index+1)"
            v-model="income.subsidyOrganization" :rules="[rules.required]"></v-text-field>
          </v-col>
          <v-col cols="12" md="5">
            <div class="text-subtitle-2">補助金額<Required/></div>
            <AmountTextField 
            :id="'補助金額-'+(index+1)"
            v-model="income.subsidyAmount" :rules="[rules.integerRule]" />
          </v-col>
          <v-col cols="12" md="2"
          ><VBtn
            color="error"
            variant="tonal"
            icon="tabler-trash"
            @click="removeIncome(index)"
            class="mt-4"
          /></v-col>
        </v-row>
      </v-card-item>
    </v-card>
    <v-form ref="formRefExpense">
    <v-card>
      <v-card-item>
        <v-card-title class="d-flex justify-space-between"> 
          <div>
            支出科目 {{formData.expenses.length}}筆
          </div>
          <div>
            
          <span class="text-subtitle-1">國訓總補助 ${{totalAmount.totalSubsidyAmount?Number(totalAmount.totalSubsidyAmount).toLocaleString():'0'}} &nbsp;+ &nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span :class="[(Number(totalAmount.totalExpense) - Number(totalAmount.totalSubsidyAmount) -Number(totalAmount.totalGovAmount) === Number(totalAmount.totalSelfFundedAmount) ? 'text-subtitle-1' : 'text-red')]">協會總自籌 ${{totalAmount.totalSelfFundedAmount?Number(totalAmount.totalSelfFundedAmount).toLocaleString():'0'}} &nbsp;+ &nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span :class="[(Number(totalAmount.totalExpense) - Number(totalAmount.totalSubsidyAmount) -Number(totalAmount.totalSelfFundedAmount) === Number(totalAmount.totalGovAmount) ? 'text-subtitle-1' : 'text-red')]">其他政府補助 ${{totalAmount.totalGovAmount?Number(totalAmount.totalGovAmount).toLocaleString():'0'}} &nbsp;= &nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span>小計總額 ${{totalAmount.totalExpense?Number(totalAmount.totalExpense).toLocaleString():'0'}}</span>
          </div>

        </v-card-title>
        <v-card
          class="mt-2 pl-15 border-opacity-25"
          variant="outlined"
          v-for="(expense, index) in visibleExpenses"
          :key="index"
        >
          <v-card-item>
            <div class="delBtnExpense">
              <VBtn
                color="error"
                variant="tonal"
                icon="tabler-trash"
                @click="removeExpense(index)"
                class="mt-4"
              />
            </div>

            <v-divider
              class="dividerVertical border-opacity-25"
              :thickness="1"
              vertical
            ></v-divider>

            <v-row>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2">核銷類型<Required/></div>
                <v-select
                  :id="`核銷類型-第${index+1}筆`"
                  v-model="expense.fieldA"
                  :items="approveType"
                  item-title="label"
                  item-value="value"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" :md="expense.itemType=='other'?'1':'2'">
                <div class="text-subtitle-2">項目<Required/></div>
                <v-select
                  :id="`項目-第${index+1}筆`"
                  v-model="expense.itemType"
                  :items="expenseItems"
                  item-title="label"
                  item-value="value"
                  clearable
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" v-if="expense.itemType=='other'">
                <div class="text-subtitle-2">其他項目<Required/></div>
                <v-text-field 
                :id="'其他項目-'+(index+1)"
                v-model="expense.otherItem" :rules="[rules.required]"></v-text-field>
                
              </v-col>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2">單價<Required/></div>
                <AmountTextField 
                :id="`單價-第${index+1}筆`"
                allow-decimal
                v-model="expense.unitPrice" :rules="[rules.twoDecimals]" />
              </v-col>
              <v-col cols="12" md="1">
                <div class="text-subtitle-2">{{ (expense.fieldA === 'consum' || expense.fieldA === 'capital') ? '數量' : '數量/人數' }}<Required/></div>
                <v-text-field 
                :id="`數量/人數-第${index+1}筆`"
                :type="(expense.fieldA === 'consum' || expense.fieldA === 'capital') ? 'number' : 'number'"
                v-model="expense.quantityOrPeople" :rules="[rules.integerRule]"></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2">天數/件數<Required/></div>
                <v-text-field 
                :id="`天數/件數-第${index+1}筆`"
                type="number"
                v-model="expense.daysOrItems" :rules="[rules.integerRule]" ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2" >小計(四捨五入)</div>
                <v-text-field :id="`小計-第${index+1}筆`" filled readonly :model-value="formatAmount(expense.subtotal, '0')" :rules="[rules.required]" bg-color="#F5F5F5"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2">國家運動訓練中心補助金額</div>
                <AmountTextField :id="`補助金額-第${index+1}筆`" readonly :model-value="expense.subsidyAmount" :disabled="formData.status==flow[0].value" :rules="[rules.required]" bg-color="#F5F5F5" />
              </v-col>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2" :rules="[rules.required]" >協會自籌金額</div>
                <AmountTextField
                  :id="`協會自籌金額-第${index+1}筆`"
                  allow-decimal
                  :rules="[
                    expense.selfFundedAmount > expense.subtotal 
                      ? '協會自籌金額超過小計' 
                      : true,
                  ]"
                  v-model="expense.selfFundedAmount"
                />
                      <!-- !!expense.selfFundedAmount?rules.twoDecimals:true -->
              </v-col>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2">其他政府補助金額</div>
                <AmountTextField
                  :id="`其他政府補助金額-第${index+1}筆`"
                  :rules="[
                    expense.govAmount > expense.subtotal 
                      ? '其他政府補助金額超過小計' 
                      : true
                  ]"
                  allow-decimal
                  v-model="expense.govAmount"
                />
              </v-col>
              <v-col cols="12" md="3">
                <div class="text-subtitle-2">備註</div>
                <v-text-field v-model="expense.remark"></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="text-right">
                <div class="text-subtitle-2">
                  憑證檔案
                  <v-icon v-if="!!expense.fieldB" icon="tabler-square-check" color="success"></v-icon>
                </div>
                <div class="d-flex justify-end">
                  <div class="text-wrap text-truncate">{{expense.fieldB}}</div>
                  <v-btn
                    color="secondary"
                    icon="tabler-photo-plus"
                    :disabled="!formData.activityTitle || formData.project.length<1 || !expense.itemType"
                    @click="openPaymentVoucherDialog(expense,index)"
                  >
                    <v-icon
                      icon="tabler-photo-plus"
                    ></v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-item>
        </v-card>
        <div
          v-if="formData.expenses.length > 0"
          ref="expenseLoadMoreSentinel"
          class="text-center text-medium-emphasis py-3"
        >
          <span v-if="hasMoreExpenses">已顯示 {{ visibleExpenses.length }} / {{ formData.expenses.length }} 筆，往下捲動載入更多</span>
          <span v-else>已顯示全部 {{ formData.expenses.length }} 筆</span>
        </div>
        
        <v-row>
          <v-col cols="12">
            <template v-if="(formData.status==flow[0].value||formData.status==flow[2].value)&&!isDelete&&userDataCookie.depNo==formData.deptNo">
              <v-btn @click="openFileUpload('consum')" variant="tonal" color="info" class="mr-2" :loading="loadingBtn">上傳消耗性器材文件</v-btn>
              <v-btn @click="openFileUpload('capital')" variant="tonal" color="info" class="mr-2" :loading="loadingBtn">上傳資本門器材文件</v-btn>
              <v-btn @click="addExpense" variant="tonal" :loading="loadingBtn">新增項目</v-btn>
            </template>
          </v-col>
        </v-row>
      </v-card-item>
    </v-card>
    </v-form>
  </v-form>
    <ExpenseReimbursementDialog
    v-if="isDialogVisible"
    v-model:isDialogVisible="isDialogVisible"
    :journey-list="journey.itemList"
    :item-list="expenseItems"
    @update-journey="updateJourney"
    :approveType="approveType"
    :is-gold="isGold"
    />
    <ExpenseFileUpload 
    v-if="fileUploadDialog"
    v-model:isDialogVisible="fileUploadDialog"
    :fileUploadType="fileUploadType"
    @updateFileDataList="updateFileDataList"
    :isReimbursement="true"
    />
    <ExpenseReimbursementSettlement
    v-if="isSettlementDialogVisible"
    v-model:isDialogVisible="isSettlementDialogVisible"
    :reimburse-apply-no="reimburseApplyNo"
    :is-gold="isGold"
    />
    <ExpenseReimbursementPaymentVoucher
    v-if="isPaymentVoucherDialogVisible"
    v-model:isDialogVisible="isPaymentVoucherDialogVisible"
    :payment-voucher-data="paymentVoucherData"
    :approve-type="approveType"
    :all-reimbursement-item="expenseItems"
    :apply-no="reimburseApplyNo"
    :schedule-id="formData.project"
    @updateFieldB="handleUpdateFieldB"
    />
</div>
</template>

<script setup lang="ts">
import {isEmptyObject, isAssociationContact} from "@/utils/deUtil";
import ExpenseReimbursementDialog from './ExpenseReimbursementDialog.vue'
import ExpenseReimbursementSettlement from './ExpenseReimbursementSettlement.vue'
import { computed, reactive, watchEffect, watch, nextTick, onBeforeUnmount } from 'vue'
import UserInfo from '../tnm/UserInfoComponent.vue';
import SignOffHistory from '../../../components/SignOffHistoryComponent.vue';
import Required from '../../../components/required.vue'
import _ from 'lodash';
import ExpenseFileUpload from './ExpenseFileUpload.vue';
import ExpenseReimbursementPaymentVoucher from './ExpenseReimbursementPaymentVoucher.vue'
definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'EXPENSEREIMBURSEMENT', //系統代碼(系統授權設定中的系統代碼)
  },
})
// approveType is defined as a computed property below
// 送出職稱設定
const submissionAsContact = useSessionStorage('SubmissionAsContact')
const EXPENSE_PAGE_SIZE = 10
const visibleCount = ref(EXPENSE_PAGE_SIZE)
const expenseLoadMoreSentinel = ref(null)
let expenseObserver = null
// dialog
const flow=reactive([
  {key:'草稿',value:'Draft'},
  {key:'送出',value:'Submitted'},
  {key:'回覆修正',value:'MReturnedForRevision'},
  {key:'重新送出',value:'Resubmitted'},
  {key:'駁回',value:'Rejected'},
  {key:'通過',value:'Passed'},    //沒有用到
  {key:'審議',value:'Reviewing'}, //沒有用到
  {key:'競技核准',value:'MApproved'},
  {key:'財務核准',value:'FApproved'},
  {key:'結案',value:'Closed'},
  {key:'收回',value:'Revoked'},
  {key:'財務退回修正',value:'FReturnedForRevision'},
])
// loading Btn
const loadingBtn = ref(false)
// 補充核銷
const fileUploadDialog = ref(false)
const fileUploadType = ref('consum')
const openFileUpload = (uploadType) => {
  fileUploadDialog.value = true
  fileUploadType.value = uploadType
}
const updateFileDataList = (dataList, uploadType) => {
  dataList.forEach((item) => {
    formData.expenses.push({
      unitPrice: item.unitPrice,
      quantityOrPeople: item.quantity,
      remark: item.remark,
      itemType: 'other', // 項目自動選'其他'
      otherItem: item.specification, // 規格填入其他項目
      daysOrItems:  1,
      fieldA: uploadType, //核銷類型
      subsidyAmount: "",
      govAmount: "",
      selfFundedAmount: "",
      fieldB: null,  //憑證檔案
    })
  })
  // 上傳後顯示到最新一筆
  visibleCount.value = formData.expenses.length
}
const checkbox=ref(false)
const actionBtn =reactive({})
const userDataCookie = useStorage('userData', {}).value
const isDelete=ref(false)
const editProject=reactive({})
const formRef = ref(null); // 使用 ref 获取表单引用
const formRefExpense = ref(null); // 使用 ref 获取表单引用
const isDialogVisible = ref(false);
const isSettlementDialogVisible = ref(false);
const route = useRoute();
const reimburseApplyNo = ref(route.query.reimburseApplyNo || '');
// 表單驗證規則
const rules = ref({
  required: value => {
    if(Array.isArray(value)){
      return value.length>0 ||'此欄位為必填'
    }else{
      return (!!value||value===0||value==="0") || '此欄位為必填'
    }
  },
  integerRule: value => {
    const n = Number(String(value ?? '').replace(/,/g, ''))
    return (!!value || value === 0) && Number.isInteger(n)
      ? true
      : '欄位為整數且必填';
  },
  twoDecimals: value => {
    if (value === '' || value === null || value === undefined) return true
    return /^-?\d+(\.\d{1,2})?$/.test(String(value).replace(/,/g, '')) || '最多小數點後兩位'
  }
});
// 活動名稱projectItemList
const projectItemList = ref([])

// 處理黃金計畫的活動名稱顯示
const displayProjectItemList = computed(() => {
  if (!projectItemList.value || projectItemList.value.length === 0) {
    return [];
  }
  
  return projectItemList.value.map(item => {
    // 如果是黃金計畫且 scheduleTitle 包含「年度費用」，則替換為「運動型保險」
    let displayTitle = item.scheduleTitle;
    if (isGold.value && displayTitle) {
      displayTitle = displayTitle.replace(/年度費用/g, '運動型保險');
    }
    
    return {
      ...item,
      displayTitle
    };
  });
});
const formData = reactive({
  refreshForm:0,
  formId:'',
  journey: {},
  applyEmpNo:userDataCookie.userno,
  deptNo:userDataCookie.depNo,
  // reimburseApplyNo: "",
  activityTitle: "",
  project: [],
  // itemName:'',
  activityName: "",
  startDate: "",
  endDate: "",
  location: "",
  participants: "",
  peopleCount: "",
  applicant: "",
  unit: "",
  status: flow[0].value,
  incomes: [],
  expenses: [],
  reviewComment:'',
  supplementary:false,
  createEmpNo:userDataCookie.userno,
  reimbursementType:"",
});
// 支出科目：先顯示 10 筆，往下捲動再載入
const visibleExpenses = computed(() => formData.expenses.slice(0, visibleCount.value))
const hasMoreExpenses = computed(() => visibleCount.value < formData.expenses.length)
const loadMoreExpenses = async () => {
  if (!hasMoreExpenses.value) return
  visibleCount.value = Math.min(visibleCount.value + EXPENSE_PAGE_SIZE, formData.expenses.length)
  await nextTick()
  // 若底部仍在視窗內且尚有未顯示資料，繼續載入
  if (hasMoreExpenses.value && expenseLoadMoreSentinel.value) {
    const rect = expenseLoadMoreSentinel.value.getBoundingClientRect()
    if (rect.top < window.innerHeight + 200) {
      await loadMoreExpenses()
    }
  }
}
const resetVisibleExpenses = () => {
  visibleCount.value = EXPENSE_PAGE_SIZE
}
const setupExpenseObserver = () => {
  if (expenseObserver) {
    expenseObserver.disconnect()
    expenseObserver = null
  }
  if (!expenseLoadMoreSentinel.value) return
  expenseObserver = new IntersectionObserver((entries) => {
    if (entries.some(entry => entry.isIntersecting)) {
      loadMoreExpenses()
    }
  }, { root: null, rootMargin: '200px', threshold: 0 })
  expenseObserver.observe(expenseLoadMoreSentinel.value)
}
// 總金額計算
const totalAmount = reactive({
  totalExpense : 0,           //支出科目 > 小計總額
  totalSubsidyAmount : 0,     //支出科目 > 國家運動訓練中心補助金額
  totalGovAmount : 0,         //支出科目 > 其他政府補助金額
  totalSelfFundedAmount : 0,  //支出科目 > 協會自籌金額
  totalIncome : 0,            //收入科目 > 補助金額
})
// 載入行程資料
const journey = reactive({})

// payment voucher dialog
const isPaymentVoucherDialogVisible = ref(false);
const paymentVoucherData = ref({})

const showAddParticipantDialog = ref(false);

const addIncomeTotal = computed(() => {
  let totalSubsidyAmount = totalAmount.totalSubsidyAmount ? Number(totalAmount.totalSubsidyAmount) : 0;
  // let totalSelfFundedAmount = totalAmount.totalSelfFundedAmount ? Number(totalAmount.totalSelfFundedAmount - totalAmount.totalIncome) : 0;
  let totalIncome = totalAmount.totalIncome ? Number(totalAmount.totalIncome) : 0;
  return (totalSubsidyAmount - totalIncome);
});

const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}
// const activityNames = reactive([]);
// const expenseItems = reactive(["住宿費", "特定活動費", "雜支"]);

const selectedParticipant = ref([])
const participantName = ref([])
const showParticipantDialog = async() => {
  if(isEmpty(formData.activityTitle)){
    popSwal('warning','請先選擇 經費需求項目名稱-經費預算申請單號','')
    return
  }
  showAddParticipantDialog.value = true;
  participantName.value = await getParticipantName()
}

const addParticipant = () => {
  if(selectedParticipant.value.length>0){
    let participants = selectedParticipant.value.map(item => item['1']).join(',')
    if(isEmpty(formData.participants)){
      formData.participants = participants
    }else{
      formData.participants += ',' + participants
    }
    selectedParticipant.value = []
    showAddParticipantDialog.value = false;
  }
}

const addIncome = () => {
  formData.incomes.push({ subsidyOrganization: "", subsidyAmount: "" });
};
const removeIncome = (index) => {
  formData.incomes.splice(index, 1);
};
const addExpense = () => {
  formData.expenses.push({
      fieldA: null, //核銷類型
      itemType: "",
      unitPrice: "",
      quantityOrPeople: "",
      daysOrItems: "",
      subtotal: "",
      subsidyAmount: "",
      govAmount: "",
      selfFundedAmount: "",
      remark: "",
      fieldB:null,  //憑證檔案
  })
  // 新增項目後直接顯示到最新一筆
  visibleCount.value = formData.expenses.length
};
const removeExpense = (index) => {
  formData.expenses.splice(index, 1);
};

const handleActivityTitle = async(clearProject:null|string) =>{
  if(clearProject){
    formData.project =[]
  }
  if(formData.activityTitle){
    await getScheduleTitle(formData.supplementary?'Y':'N')
  }else{
    projectItemList.value.splice(0,projectItemList.value.length)
  }
}
const handleProject = async() =>{
  if(formData.activityTitle&&formData.project.length>0){
    await getScheduleList()
  }else{
    Object.assign(journey,{})
  }
}

function convertToArray(selectStr) {
  // 去掉字串中的單引號，然後用逗號分割成陣列
  return selectStr.replace(/'/g, '').split(',')
};
// 驗證 v-form
const submitForm = async () => {
  const valid = await formRef.value.validate();
  return valid.valid
};
const submitFormExpense = async () => {
  const valid = await formRefExpense.value.validate();
  return valid.valid
};
const checkTableExpense = async()=>{
  const {valid , errors} = await formRef.value.validate();
  if(!valid){
    return errors.map(item => item.id)
  }
  const allExist = checkProjectInProjectItemList()
  if(!allExist && formData.status==flow[0].value){
    return '活動名稱被核銷過囉 點選補充核銷找找吧'
  }
  // 送出前展開全部項目，確保表單驗證涵蓋所有欄位
  visibleCount.value = formData.expenses.length
  await nextTick()
  const {valid:validExpense, errors:errorsExpense} = await formRefExpense.value.validate();
  if(!validExpense){
    return errorsExpense.map(item => item.id)
  }

  return ''
}
const checkSaveDate = async() =>{
  let activityName = ''
  if(formData.status==flow[0].value){
    activityName = formData.project.map(projectId => {
        const found = projectItemList.value.find(projectItem => projectItem.scheduleId === projectId)
        if (found) {
        return found.scheduleTitle
      }
      return ''
    }).filter(Boolean).toString()
  }else{
    activityName = formData.activityName
  }
  let form ={
    reimburseApplyNo: reimburseApplyNo.value,
    applyNo: formData.activityTitle,
    item:formData.project.toString(),
    activityName: activityName.toString(),
    activityStartDate: rocToWestern(formData.startDate,'-','-'),
    activityEndDate: rocToWestern(formData.endDate,'-','-'),
    location:formData.location,
    participants: formData.participants,
    totalMember: formData.peopleCount,
    supplementary: formData.supplementary?"Y":'N',
  }
  return form
}
// 儲存btn
const save = async() => {
  const validCheckTableExpense = await checkTableExpense()
  if(validCheckTableExpense==""){
      const form = await checkSaveDate()
      form.reimburseApplyNo = ''
      addExpenseReimbursement(form,formData.expenses,formData.incomes)
  }else{
    popSwal('warning','申請資訊不足',validCheckTableExpense)
  }
};
// 編輯儲存btn
const editSave = async() => {
  const validCheckTableExpense = await checkTableExpense()
  if(validCheckTableExpense==''){
      const form = await checkSaveDate()
      updateExpenseReimbursement(form,formData.expenses,formData.incomes, true)
  }else{
    popSwal('warning','申請資訊不足',validCheckTableExpense)
  }
};
// 編輯btn 在submit狀態下修改
const editInSubmit = async() => {
  const validCheckTableExpense = await checkTableExpense()
  if(validCheckTableExpense==""){
      const form = await checkSaveDate()
      updateExpenseReimbursement(form,formData.expenses,formData.incomes, true)
  }else{
    popSwal('warning','申請資訊不足',validCheckTableExpense)
  }
};
const updateStatusDate = async(status) =>{
  let form ={
    reimburseApplyNo:reimburseApplyNo.value,
    status:status,
    remark:formData.reviewComment,
  }
  return form
}
// 送出btn
const send = async() => {
  const validCheckTableExpense = await checkTableExpense()
  if(validCheckTableExpense==""){
      const form = await checkSaveDate()
      try {
        await updateExpenseReimbursement(form, formData.expenses, formData.incomes, false);
        // 成功處理邏輯
        let nowAmount = Number(journey?.expenseTotal ?? 0) - Number(journey?.reimburseTotal ?? 0)
        if(addIncomeTotal.value>=0){
          if(nowAmount< Number(addIncomeTotal.value)){
            const message = `剩餘預算 ${nowAmount.toLocaleString()} 元，不足以支付本次申請的 ${Number(addIncomeTotal.value).toLocaleString()} 元。`
            popSwal('error','核銷費用已超過剩餘預算', message)
          }else{
            const form = await updateStatusDate(flow[1].value)
            updateStatusExpenseReimbursement(form)
          }
        }else{
          popSwal('error','預計核銷金額錯誤','收入科目-總補助 > 支出科目-國訓總補助')
        }
      } catch (error) {
        popSwal('error',error,'')
        console.error('更新經費核銷失敗', error);
        // 在這裡處理錯誤
      }
  }else{
    popSwal('warning',validCheckTableExpense,'支出科目')
  }
}
// 刪除btn
const deleteBtn = async() => {
  $swal({
    title: `刪除資料`,
    text: `${reimburseApplyNo.value}`,
    showCancelButton: true,
    confirmButtonText: "我要刪除",
    cancelButtonText: "取消",
  }).then(async(result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      deleteExpenseReimbursement(reimburseApplyNo.value)
    }
  });
}
// revoke 收回btn
const revoke = async ()=>{
  const form = await updateStatusDate(flow[10].value)
  updateStatusExpenseReimbursement(form)
}
//returnedForRevision 退回修正
const returnedForRevision =async ()=>{
  const form = await updateStatusDate(flow[2].value)
  updateStatusExpenseReimbursement(form)
}
//rejected 駁回Btn
const rejected = async () =>{
  const isFinanceReview = formData.status === flow[6].value || formData.status === flow[7].value
  const hint = isFinanceReview 
    ? '請在下方輸入確認' 
    : '請在下方輸入確認。<br>如果只需修正，請改點「回覆修正」按鈕。'

  $swal({
    title: `如果駁回此申請單就作廢了，確定要駁回嗎?`,
    html: hint,
    input: 'text',
    inputPlaceholder: '輸入 確認 以駁回',
    showCancelButton: true,
    confirmButtonText: "我要駁回",
    cancelButtonText: "取消",
    inputValidator: (value) => {
      if (value !== '確認') {
        return '請輸入「確認」以繼續'
      }
    }
  }).then(async(result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      const form = await updateStatusDate(flow[4].value)
      updateStatusExpenseReimbursement(form)
    }
  });
}
//pass 通過Btn
const pass =async()=>{
  const valid= await submitForm()
  const validExpense= await submitFormExpense()
  if(valid &&validExpense){
    const form = await updateStatusDate(flow[7].value)

    updateStatusExpenseReimbursement(form)
  }
}

// 財務 FreturnedForRevision
const FreturnedForRevision =async ()=>{
    const form = await updateStatusDate(flow[11].value)
    updateStatusExpenseReimbursement(form)
}
// 財務 Fapproved
const Fapproved =async ()=>{
  const form = await updateStatusDate(flow[8].value)
  updateStatusExpenseReimbursement(form)
}

const resetForm = () => {
  formRef.value.reset(); // 使用 formRef 重置表单
};

// dialog-載入行程
const handleDialogVisiable = async() => {
  if (journey && Object.keys(journey).length === 0 && journey.constructor === Object) {
    await handleProject();
  }
  isDialogVisible.value = true;
};
// 載入行程dialog emit
const updateJourney = (val) => {
  // isDialogVisible.value = false;
  // console.log('updateJourney',val);
  // val.map(item => {
  //   let data={
  //     itemType: item.itemType,
  //     otherItem: item.itemType=='other'?(item.otherItem?item.otherItem:item.itemOther):'',
  //     unitPrice: item.unitPrice,
  //     quantityOrPeople: item.quantity,
  //     daysOrItems: item.days?item.days:1,
  //     subtotal: item.subtotal,
  //     subsidyAmount: '',
  //     selfFundedAmount: '',
  //     remark: "",
  //   }
  //   formData.expenses.push(data)
  // });
  val.forEach((it)=>{
    const data = expenseItems.value.find((itemData)=>itemData.value===it.itemType)
    if(data){
      formData.expenses.push({
        fieldA: it.approveType,
        itemType: it.itemType,
        otherItem: it.itemType=='other'?(it.itemOther??it.itemType):'',
        unitPrice: it.unitPrice,
        quantityOrPeople: it.quantity,
        daysOrItems: it.days?it.days:1,
        subtotal: it.subtotal,
        govAmount: '',
        subsidyAmount: 0,
        selfFundedAmount: '',
        remark: "",
        fieldB:null,
      })
    }else{
      // return{
      //   ...it,
      //   itemOther:it.itemType,
      //   itemType:'other',
      // }
      formData.expenses.push({
        fieldA: it.approveType,
        itemType: 'other',
        otherItem: it.itemType,
        unitPrice: it.unitPrice,
        quantityOrPeople: it.quantity,
        daysOrItems: it.days??1,
        subtotal: it.subtotal,
        govAmount: '',
        subsidyAmount: 0,
        selfFundedAmount: '',
        remark: "",
        fieldB:null,
      })
    }
  })
  // 載入行程後顯示到最新一筆
  visibleCount.value = formData.expenses.length
};

//結算表
const clickSettlement =()=>{
  isSettlementDialogVisible.value=true
} 

// API----------------------------------------------------------------------------
// 支出科目-項目 -- 簡易公用表格 CountyAndCity
const { data: getExpenseItems, execute: fetchItem } = await useApi<any>(createUrl('/q/de/select/select/select/deSelect', {
  query: {
    tabId: 'Reimbursement'
  },
}))
const expenseItems = computed(()=>{
  if(getExpenseItems.value&&getExpenseItems.value.length>0){
    let data={
      label:'其他',
      value:'other',
    }
    return [...getExpenseItems.value, data];
  }else{
    return []
  }
})

// 經費需求名稱 v-select
///tca/expenserequestlist/getProjectForReimb
const { data: projectForReimb, execute: getProjectForReimb } = await useApi<any>(createUrl('/tca/expenserequestlist/getProjectForReimb', {
  query: {},
}))
const activityNames = computed(()=>projectForReimb.value?projectForReimb.value:[])

// 判斷是否為黃金計畫
const isGold = computed(() => {
  console.log('--- isGold computed ---');
  console.log('formData.activityTitle:', formData.activityTitle);
  console.log('activityNames.value:', activityNames.value);
  
  if (formData.activityTitle && activityNames.value.length > 0) {
    const selectedProject = activityNames.value.find(item => item.applyNo === formData.activityTitle)
    console.log('selectedProject:', selectedProject);
    console.log('selectedProject?.isGold:', selectedProject?.isGold);
    const result = selectedProject?.isGold === 'Y'
    console.log('isGold result:', result);
    return result
  }
  console.log('isGold result: false (no activityTitle or activityNames)');
  return false
})

const approveType = computed(() => {
  return [
    {label:'培訓', value:'train'},
    {label: isGold.value ? '運動型保險' : '年度', value:'annual'},
    {label:'消耗性', value:'consum'},
    {label:'資本門', value:'capital'},
  ]
})

const getScheduleTitle = async(supplementary) =>{
  try {
    const response = await $api('/tca/expenseReimbursement/getScheduleTitle', {
      method: 'POST',
      body: {
        applyNo:formData.activityTitle,
        supplementary,
      },
    });
    projectItemList.value.splice(0,projectItemList.value.length, ...response)
    // return response
  } catch (error) {
    projectItemList.value.splice(0,projectItemList.value.length)
    console.error('Error during getScheduleList:', error);
  }
}
// 載入行程 v-select
const getScheduleList = async () => {
  try {
    const response = await $api('/tca/expenseReimbursement/getScheduleList', {
      method: 'POST',
      body: {
        scheduleIds:formData.project,
      },
    });
    Object.assign(journey,response)
  } catch (error) {
    console.error('Error during getScheduleList:', error);
  }
}


// 取得可執行動作API
const getFormActions = async (formId) => {
  let apiUrl = '/form/getFormActions/' + formId;
  await $api(apiUrl, {
    method: 'GET',
  }).then((resp) => {
    if (resp ) {
      Object.assign(actionBtn, resp);
    } else {
      console.error("Invalid response structure", resp);
    }
  }).catch((error) => {
    console.error("API request failed", error);
  });
};
// 刪除經費核銷申請 API
const deleteExpenseReimbursement = async (body) => {
  loadingBtn.value=true
  let apiUrl='/tca/expenseReimbursement/delete/'+reimburseApplyNo.value
  await $api(apiUrl, {
    method: 'DELETE'
  }).then((resp) => {
    popSwal('success',resp.message||'刪除成功','')
    isDelete.value=true
    loadingBtn.value=false
  }).catch((error) => {
    popSwal('error','刪除失敗','刪除')
    loadingBtn.value=false
  });
};
// 更新經費核銷申請 狀態 API
const updateStatusExpenseReimbursement = async (body) => {
  loadingBtn.value=true
  await $api('/tca/expenseReimbursement/updateStatus', {
    method: 'POST',
    body: body,
  }).then((resp) => {
    // 檢查 API 響應中的 result 字段
    if(resp&&resp.data){
      popSwal('success',resp.message?resp.message.replace('Error:',''):'更新狀態成功','')
    }else{
      return Promise.reject(new Error(resp.message))
    }
    Object.assign(editProject, resp.data)
    if(resp.data.expReimb.formId){
      getFormActions(resp.data.expReimb.formId)
      formData.refreshForm+=1
    }
    loadingBtn.value=false
  }).catch((error) => {
    popSwal('error',error?error:'失敗 請稍後再試','更新')
    loadingBtn.value=false
  });
};
// 更新經費核銷申請資訊API
const updateExpenseReimbursement = async (expReimb, expensesList, incomeList, showPop) => {
  loadingBtn.value = true;
  try {
    const resp = await $api('/tca/expenseReimbursement/update', {
      method: 'POST',
      body: {
        expReimb: expReimb,
        expensesList: expensesList,
        incomeList: incomeList,
      },
    });


    Object.assign(editProject, resp);
    loadingBtn.value = false;

    if (showPop) {
      popSwal('success', resp.message || '編輯成功', '');
    }
    // formData.refreshForm+=1
  } catch (error) {
    loadingBtn.value = false;

    popSwal('error', '編輯失敗 請稍後再試', '編輯');
    
    throw error; // 往上拋錯誤
  }
};
// 新增經費核銷申請API
const addExpenseReimbursement = async (expReimb,expensesList,incomeList) => {
  loadingBtn.value=true
  await $api('/tca/expenseReimbursement/add', {
    method: 'POST',
    body: {
      expReimb:expReimb,
      expensesList:expensesList,
      incomeList:incomeList,
    },
  }).then((resp) => {
    popSwal('success','新增成功','')
    // getExpenseReimbursement(resp.expReimb.reimburseApplyNo)
    Object.assign(editProject, resp)
    loadingBtn.value=false
  }).catch((error) => {
    popSwal('error','儲存失敗 請稍後再試','儲存')
    loadingBtn.value=false
  });
};
// 取得經費核銷申請API
const getExpenseReimbursement = async () => {
  let apiUrl='/tca/expenseReimbursement/get/'+reimburseApplyNo.value
  await $api(apiUrl, {
    method: 'GET', //依據後端 restful api 的 method 設定
  }).then((resp) => {
    Object.assign(editProject, resp)
    // updateForm()
    if(resp.expReimb.formId){
      getFormActions(resp.expReimb.formId)
    }
  })
};

// 取得此筆所有fildId
const queryInvoiceData = async (itemId) => {
  if (!itemId) {
    popSwal('error', '請選擇核銷項目', '');
    return [];
  }
  let apiUrl = '/tca/expenseReimbursement/queryInvoiceData';
  try {
    const resp = await $api(apiUrl, {
      method: 'POST',
      body: {
        applyNo: formData.activityTitle,
        scheduleIds: formData.project,
        itemId
      },
    });
    return resp.data;
  } catch (error) {
    console.error('Error during getScheduleList:', error);
    return [];
  }
};

const getParticipantName = async () => {
  let apiUrl = '/tca/expenseReimbursement/getMemberList';
  try {
    const resp = await $api(apiUrl, {
      method: 'POST',
      query: {
        applyNo: formData.activityTitle,
      },
    });
    return resp.data;
  } catch (error) {
    console.error('Error during getParticipantName:', error);
    return [];
  }
}

const checkScheduleId = async (body) => {
  let apiUrl = '/tca/expenseReimbursement/checkScheduleId';
  try {
    const resp = await $api(apiUrl, {
      method: 'POST',
      body,
    });
    return resp.data;
  }
  catch (error) {
    console.error('Error during checkScheduleId:', error);
    return [];
  }
}
// ---------------------------------------------------------------API
const openPaymentVoucherDialog = async (item,index) => {
  isPaymentVoucherDialogVisible.value = true;
  console.log('item',item,index)
  const invoiceData = await queryInvoiceData(item.itemType)
  console.log('invoiceData',invoiceData)
  Object.assign(paymentVoucherData.value ,{...item,index, invoiceData});
  console.log('paymentVoucherData',paymentVoucherData.value)
}

const handleUpdateFieldB = (selectedIds:string[]) => {
  isPaymentVoucherDialogVisible.value = false;
  formData.expenses[paymentVoucherData.value.index].fieldB = selectedIds.toString()
}

const checkProjectInProjectItemList = () => {
  let allExist = formData.project.every(projectId => 
    projectItemList.value.some(item => item.scheduleId === projectId)
  );
  return allExist
}
const updateForm = async() => {
  let data = JSON.parse(JSON.stringify(editProject.expReimb))
  // console.log('data',data.item.split(','))
  data ={
    ...data,
    // project:data.item.split(','),
    activityTitle:data.applyNo,
    supplementary:data.supplementary=='Y'?true:false,

    applicationNumber:data.projectId,
    startDate:westernToRoc(data.activityStartDate,'-','-'),
    endDate:westernToRoc(data.activityEndDate,'-','-'),
    participants:data.participants,
    peopleCount:data.totalMember,
    
  }
  Object.assign(formData,data)
  reimburseApplyNo.value = (data.reimburseApplyNo);
  
  // // 經費核銷申請名稱 活動名稱 載入行程
  // formData.project = (_.cloneDeep(editProject.expReimb.item)).split(',');
  // console.log('formData.project',formData.project)
  // formData.activityTitle = _.cloneDeep(editProject.expReimb.applyNo);
  // formData.supplementary = _.cloneDeep(editProject.expReimb.supplementary) == "Y" ? true : false;
  // formData.activityName = _.cloneDeep(editProject.expReimb.activityName);
  // // formData.itemName = _.cloneDeep(editProject.expReimb.itemName ? editProject.expReimb.itemName : '');
  
  // formData.applicationNumber = _.cloneDeep(editProject.expReimb.projectId);
  // formData.status = _.cloneDeep(editProject.expReimb.status);
  // formData.applyEmpNo = _.cloneDeep(editProject.expReimb.applyEmpNo);
  // formData.deptNo = _.cloneDeep(editProject.expReimb.deptNo);
  // formData.startDate = westernToRoc(_.cloneDeep(editProject.expReimb.activityStartDate), '-', '-');
  // formData.endDate = westernToRoc(_.cloneDeep(editProject.expReimb.activityEndDate), '-', '-');
  // formData.location = _.cloneDeep(editProject.expReimb.location);
  // formData.participants = _.cloneDeep(editProject.expReimb.participants);
  // formData.peopleCount = _.cloneDeep(editProject.expReimb.totalMember);
  // formData.createEmpNo = _.cloneDeep(editProject.expReimb.createEmpNo);
  
  // 深層複製並更新 arrays
  formData.project.splice(0, formData.project.length, ...data.item.split(','))
  formData.expenses.splice(0, formData.expenses.length, ..._.cloneDeep(editProject.expensesList));
  formData.incomes.splice(0, formData.incomes.length, ..._.cloneDeep(editProject.incomeList));
  resetVisibleExpenses()
  
  formData.formId = _.cloneDeep(editProject.expReimb.formId);
  await handleActivityTitle();
  handleProject();
  const allExist = checkProjectInProjectItemList()
  if(!allExist && formData.status==flow[0].value){
    const resp = await checkScheduleId({
      applyNo: formData.activityTitle,
      scheduleIds: formData.project,
    })
    formData.project.splice(0, formData.project.length)
    const newScheduleIds = resp.filter(item => item.status == 'Success').map(item => item.newScheduleId)
    const failedScheduleIds = resp.filter(item => item.status == 'Fail')
    formData.project.splice(0, formData.project.length, ...newScheduleIds)
    console.log(failedScheduleIds)
    if(failedScheduleIds.length > 0){
      let text = failedScheduleIds.map(item => `${item?.scheduleName??item.orgScheduleId} ${item?.msg??'已消失'}`).join('\n')
      popSwal('error','活動名稱錯誤提示','以下行程未找到：'+text)
    }
  }
}

// 監聽 items 內部的變動，當 unitPrice 或 quantityOrPeople 改變時，自動更新 subtotal
watch(formData.expenses,()=>{
  // console.log('expense')
  if(formData.expenses.length>0){
    // 國家運動訓練中心補助金額
    totalAmount.totalSubsidyAmount = 0
    // 協會自籌金額
    totalAmount.totalSelfFundedAmount = 0
    // 小計
    totalAmount.totalExpense = 0
    // 其他政府補助金額
    totalAmount.totalGovAmount = 0
    formData.expenses.map((item)=>{
      // 計算支出科目 >單筆 小計&國家運動訓練中心補助金額
      if(item.unitPrice&&item.quantityOrPeople&&item.daysOrItems){
        let selfFundedAmount = item.selfFundedAmount?Number(item.selfFundedAmount):0
        let govAmount = item.govAmount?Number(item.govAmount):0
        let total = Math.round(Number(item.unitPrice)*Number(item.quantityOrPeople)*Number(item.daysOrItems))
        item.subtotal= total
        // 國家運動訓練中心補助金額 = 小計 - 協會自籌 不得為負
        item.subsidyAmount= (total-selfFundedAmount-govAmount) < 0 ? 0: (total-selfFundedAmount-govAmount)
      }
      // else{
      //   item.subtotal = 0
      //   item.subsidyAmount = 0
      //   item.govAmount = 0
      // }
      // 計算總金額(國家運動訓練中心補助金額&協會自籌&總支出)
      totalAmount.totalSubsidyAmount+=item.subsidyAmount?Number(item.subsidyAmount):0
      totalAmount.totalSelfFundedAmount+=item.selfFundedAmount?Number(item.selfFundedAmount):0
      totalAmount.totalExpense+=item.subtotal?Number(item.subtotal):0
      totalAmount.totalGovAmount+=item.govAmount?Number(item.govAmount):0
    })
  }
})

watch(editProject, () => {
  updateForm();
});

// 使用 watch 監控查詢參數變化
watch(() => route.query.reimburseApplyNo, async (newValue) => {
  if (newValue !== reimburseApplyNo.value) {
    reimburseApplyNo.value = newValue || '';
    // project.reimburseApplyNo = newValue || '';
    getExpenseReimbursement();
  }
});
watch(() => route.query.applyNo, async () => {
  if(route.query.applyNo){
    formData.activityTitle = route.query.applyNo;
  }
});

async function executeInOrder() {
  loadingBtn.value=true
  // 先將 checkbox 的值設為 false
  checkbox.value = false;

  // 等待 getExpenseReimbursement() 完成
  await getExpenseReimbursement();

  // await getProjectList(formData.deptNo);

  // 等待 getScheduleTitle() 完成
  await handleActivityTitle();
  loadingBtn.value=false
}
// onMounted 用來初始化數據
onMounted(async () => {
  reimburseApplyNo.value = route.query.reimburseApplyNo || '';
  if(route.query.reimburseApplyNo){
    executeInOrder()
  }
  // else{
  //   getProjectList(userDataCookie.depNo)
  // }
  if(route.query.applyNo){
    formData.activityTitle = route.query.applyNo;
    getScheduleTitle();

  }
  await nextTick()
  setupExpenseObserver()
});

watch(() => formData.expenses.length, async () => {
  await nextTick()
  setupExpenseObserver()
})

onBeforeUnmount(() => {
  if (expenseObserver) {
    expenseObserver.disconnect()
    expenseObserver = null
  }
})

</script>

<style scoped>
.v-card {
  margin-bottom: 20px;
}
.delBtnExpense {
  position: absolute;
  left: 13px;
  top: 32%;
}
.dividerVertical {
  position: absolute;
  height: 100%;
  left: 65px;
  top: 0px;
}
.text-red{
  color:red;
}

</style>
